<template>
  <SeoPage page-key="creazioneSitiWebBellinzona" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'CreazioneSitiWebBellinzonaPage'
})
</script>

